import React, {useState, useEffect} from 'react';
import { getImages } from '../Const';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Formik, Form, Field } from 'formik';

const SetAppointmentModal = ({ close, leadData, updateLeadDataMultiple }) => {

    const handleSubmit = (e) => {
        e.preventDefault();

        //String(v.created_at_obj.getMonth() + 1).padStart(2, '0') + "/" + String(v.created_at_obj.getDate()).padStart(2, '0') + "/" + String(v.created_at_obj.getFullYear()).substr(-2)

        const dateString = String(formData.appointment_date.getFullYear()) + "-" + String(formData.appointment_date.getMonth() + 1).padStart(2, '0') + "-" + String(formData.appointment_date.getDate()).padStart(2, '0');
        const date = new Date(dateString + " " + formData.appointment_time);

        var values = {
            'id':formData.lead_id,
            'appraisal_stage':'InQueue',
            'lead_type':leadData.lead_type,//'InPerson',
            'appointment_date': date,
            'appointment_note': formData.comments,
            'location':formData.location,
            'no_show':0
        }

        console.log(formData,date,values);

        updateLeadDataMultiple(values);

        close();
    }

    const [formData, setFormData] = useState({
        lead_id:leadData?.id,
        location:leadData?.location,
        appointment_date: new Date(),
        appointment_time: '08:00 AM',
        comments: ""
    });

    useEffect(() => {
        console.log(leadData);
        setFormData({
            lead_id:leadData?.id,
            location:leadData?.location,
            appointment_date: new Date(),
            appointment_time: '08:00 AM',
            comments: ""
        })
    },[leadData]);

    const onChangeInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.value
        })
    }

    const [times, setTimes] = useState([]);

    useEffect(() => {
        const times = [];
        for (let i = 0; i < 24; i++) {
            // Hour in 24-hour format
            const hour = i;
        
            // Create a Date object for the hour
            const dateAtHour = new Date();
            dateAtHour.setHours(hour, 0, 0, 0); // Set minutes, seconds, milliseconds to 0
        
            // Add the full hour
            times.push(dateAtHour.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }));
        
            // Add the half-hour mark
            const dateAtHalfHour = new Date(dateAtHour);
            dateAtHalfHour.setMinutes(30);
            times.push(dateAtHalfHour.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }));
          }

        setTimes(times);
    }, []);

    return (
        <>
            <div className="modal-header">
                <h1 className="modal-title" id="staticBackdropLabel">Set Appointment</h1>
                <button className="sm-box-close" type="button" onClick={close}>
                    <img src={getImages('close-anticon.png')} alt="Close" />
                </button>
            </div>
            <form className='begin-form follow-up-form sa-form' onSubmit={handleSubmit}>
                <div className="modal-body p-0">
                    <div className='p-5'>
                        <div className='row gx-5'>
                            <div className='col-md-6 mb-md-0 mb-3'>
                                <div className='md-title text-uppercase mb-3'>Appointment Details</div>
                                <div className='sa-box'>
                                    <div className='form-group mb-4'>
                                        <DatePicker
                                            selected={formData.appointment_date}
                                            onChange={(date) => setFormData({...formData,'appointment_date':date})}
                                            inline
                                            disabled
                                        />
                                    </div>
                                    <div className='row gx-5'>
                                        <div className='col-md-6 mb-md-0 mb-3'>
                                            <label>Select Time</label>
                                            <select name="appointment_time" className='form-control' onChange={onChangeInput}>
                                                {times.map((time, index) => (
                                                    <option key={index} value={time}>{time}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='col-md-6'>
                                            <label>Location</label>
                                            <select name="location" className='form-control' value={formData.location} onChange={onChangeInput}>
                                                <option value="POMPANO BEACH">Pompano Beach</option>
                                                <option value="BOYNTON BEACH">Boynton Beach</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='md-title text-uppercase mb-3'>Notes</div>
                                <div className='sa-box'>
                                    <label>Comments</label>
                                    <textarea name="comments" className='form-control' value={formData.comments} onChange={onChangeInput}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type='submit' className='blue-btn'>Submit</button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default SetAppointmentModal;
